import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const clientColumn: MaterialOrderRequestColumn = {
    title: 'Клиент',
    key: 'client',
    width: 180,
    render: (_value, record) => record.shipment?.client?.name || '—',
}
